export default function beforeAuth({ next, router }) {
    if (localStorage.getItem('child_token')) {
        return router.push({ name: 'Child Contents' });
    }
  
    return next();
  }